import { render } from "./user-tabset.vue?vue&type=template&id=430a1011"
import script from "./user-tabset.vue?vue&type=script&lang=js"
export * from "./user-tabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__